import { render } from "./StatComp.vue?vue&type=template&id=cfb01796&scoped=true&ts=true"
import script from "./StatComp.vue?vue&type=script&lang=ts"
export * from "./StatComp.vue?vue&type=script&lang=ts"

import "./StatComp.vue?vue&type=style&index=0&id=cfb01796&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfb01796"]])

export default __exports__